export const humanReadableDate = (date: string) =>
  date
    ? new Date(date).toLocaleDateString("en-US", {
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    : new Date();
